export const initialState = {}


// WEBPACK FOOTER //
// ./src/interface/store/departments/mapbox/selectors.js